import { useState, useEffect, memo, useRef } from "react";
import style from "./../index.module.scss";
import styleUi from "./NewOtherEvent.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import CheckIcon from '@mui/icons-material/Check';
import PotItem from "../../comm/global/components/PotItem";
import SelRewildingMode from "../../comm/global/components/SelRewildingMode";
import DateTimeSel from "../../comm/global/components/DateTimeSel";
import MeetPoint from "../../comm/global/components/MeetPoint";
import { CustomEventManager } from "../../comm/global/CustomEventManager";
import PlacesInput from "../../comm/global/components/PlacesInput";
const customEventManager = new CustomEventManager();
const NewOtherEvent = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [data, set_data] = useState({ name: "", pot: null, bg: null, member: 5, meetPlace: "" });
    const items = [
        { id: 0, "type": "user", "record": false, "name": "九份", "lat": 25.1094, "lng": 121.8453 },
        { id: 1, "type": "user", "record": false, "name": "金瓜石", "lat": 25.1155, "lng": 121.8584 },
        { id: 2, "type": "user", "record": false, "name": "猴硐", "lat": 25.0981, "lng": 121.8143 },
        { id: 3, "type": "user", "record": false, "name": "瑞芳", "lat": 25.1089, "lng": 121.8042 },
        { id: 4, "type": "user", "record": false, "name": "石碇", "lat": 24.9536, "lng": 121.6373 },
        { id: 5, "type": "user", "record": false, "name": "大溪老街", "lat": 24.9316, "lng": 121.2878 },
        { id: 6, "type": "user", "record": false, "name": "大湖草原", "lat": 24.4442, "lng": 121.3063 },
        { id: 7, "type": "user", "record": false, "name": "石梯坪", "lat": 24.4254, "lng": 121.8084 },
        { id: 8, "type": "user", "record": false, "name": "十分瀑布", "lat": 25.0401, "lng": 121.7722 },
        { id: 9, "type": "user", "record": false, "name": "深澳湾", "lat": 25.0316, "lng": 121.9108 }
    ];
    useEffect(() => {
        setInProp(true);
    }, []);
    useEffect(() => {
        setInProp(true);
        customEventManager.addEventListener("selPot", selPot);
        return () => {
            customEventManager.removeEventListener("selPot", selPot);
        }
    }, [])

    const selPot = async (pot) => {
        //刪掉在此modal之後的所有modal
        addModalType({ cmd: "delAfter", cls: "NewOtherEvent" });
        set_data(prop => { return { ...prop, pot: pot } })
    }
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "NewOtherEvent"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <YStyled.Span size={17}>新增行程</YStyled.Span>
                                    <YStyled.Span size={11}>oosa.com</YStyled.Span>
                                    <img src="./assets/ui/x.png" onClick={e => {
                                        setInProp(false);
                                    }} />
                                </div>
                                <div className={styleUi.view}>
                                    <YStyled.Span size={22} style={{ marginTop: "2rem" }}>新增行程</YStyled.Span>
                                    <YStyled.Row style={{ marginTop: "1.4rem" }}>
                                        <YStyled.Span size={17} >行程名稱</YStyled.Span>
                                    </YStyled.Row>
                                    <YStyled.Label style={{ width: "100%", marginTop: ".6rem" }}>
                                        <YStyled.Input value={""} size={14} type="text" placeholder="" />
                                    </YStyled.Label>
                                    <YStyled.Row style={{ marginTop: "1.4rem", marginBottom: ".6rem" }}>
                                        <YStyled.Span size={17} >地點</YStyled.Span>
                                    </YStyled.Row>

                                    {data.pot ?
                                        <div className={styleUi.potBox}>
                                            <YStyled.Label style={{ width: "100%" }}>
                                                <YStyled.Row gap=".8rem" align={"flex-start"}>
                                                    <img src='./assets/ui/postion.png' />
                                                    <YStyled.Col align={"flex-start"} gap={".4rem"}>
                                                        <YStyled.Span size={17}>{data.pot.name}</YStyled.Span>
                                                        <YStyled.Span size={13} color={"#00000028"}>{data.pot.info}</YStyled.Span>
                                                    </YStyled.Col>
                                                </YStyled.Row>
                                                <img src="./assets/ui/x.png" style={{ position: "absolute", top: "10%", right: "4%",cursor:"pointer" }} onClick={e=>{
                                                    set_data(prev=>({...prev,pot:null}))
                                                }} />
                                            </YStyled.Label>
                                        </div>
                                        :
                                        <div className={styleUi.location} onClick={e => {
                                            addModalType({
                                                cls: "SelectPot", arg: {
                                                    cb: (sel) => {
                                                        if (sel === "formMap") {
                                                            addModalType({
                                                                cls: "SearchMapModal", arg: {
                                                                    cb: (pot) => {
                                                                        console.log("pot", pot)
                                                                        set_data(prop => { return { ...prop, pot: pot } })
                                                                    }
                                                                }
                                                            })
                                                        }
                                                        else if (sel === "exitsList") {
                                                            addModalType({
                                                                cls: "OpenPotList", arg: {
                                                                    cb: () => {
                                                                    },
                                                                    type: "selPot"
                                                                }
                                                            })
                                                        }
                                                    }
                                                }
                                            })
                                        }}>
                                            <img src="./assets/ui/Location_b.png"></img>
                                            <YStyled.Span size={13} >加入地點</YStyled.Span>
                                        </div>
                                    }
                                    <YStyled.Row style={{ margin: "1.4rem 0" }}>
                                        <YStyled.Span size={17} >野放模式</YStyled.Span>
                                    </YStyled.Row>
                                    <SelRewildingMode />

                                    <YStyled.Row style={{ marginTop: "1.4rem" }}>
                                        <YStyled.Span size={17} >時間</YStyled.Span>
                                    </YStyled.Row>
                                    <YStyled.VPanel align="center" style={{ marginTop: "1rem" }}>
                                        <DateTimeSel label={"開始"} />
                                        <YStyled.Hr height=".5rem" />
                                        <DateTimeSel label={"結束"} />
                                    </YStyled.VPanel>
                                    <YStyled.Row style={{ margin: "1.4rem 0 1rem 0" }}>
                                        <YStyled.Span size={17} >集合點</YStyled.Span>
                                    </YStyled.Row>
                                    <PlacesInput placeholder="輸入地點" type={1}/>
                                    
                                    <YStyled.Row style={{ margin: "1.4rem 0 1rem 0" }}>
                                        <YStyled.Span size={17} >成員</YStyled.Span>
                                        <YStyled.Span size={15} className={styleUi.addSpan} style={{ cursor: "pointer" }} onClick={e => {
                                            addModalType({
                                                cls: "AddMember", arg: {
                                                    
                                                }
                                            })
                                        }}>新增 +</YStyled.Span>
                                    </YStyled.Row>
                                    <div className={styleUi.users}>
                                        <FriendInfo type={3} />
                                        <div className={styleUi.userItem}>
                                            <FriendInfo type={4} />
                                            <img src="./assets/ui/x.png"></img>
                                        </div>
                                    </div>
                                </div>
                                <YStyled.BTN3 className={`${styleUi.btn} ${false ? "" : styleUi.disabled}`} onClick={e => {

                                }}>
                                    <YStyled.Span size={17} >完成</YStyled.Span>
                                </YStyled.BTN3>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(NewOtherEvent);
